export const imageExtensionValidation = (extension:string) => {
    if(extension.trim() === "") return false
    let allowedExtensions = "jpg,jpeg,png,gif,bmp,tiff,svg";
    return(allowedExtensions.indexOf(extension.toLocaleLowerCase()) > -1)
}

export const pdfExtensionValidation = (extension:string) => {
    if(extension.trim() === "") return false
    let allowedExtensions = "pdf";
    return(allowedExtensions.indexOf(extension.toLocaleLowerCase()) > -1)
}